import React, { useState } from "react"
import { TabContent, TabPane, Nav, NavItem, NavLink, Card } from "reactstrap"
import IpWarmupForm from "./IpWarmupForm"
import PriceConverterForm from "./PriceConverterForm"
import PriceCalculatorForm from "./PriceCalculatorForm"
import { useSearchParams } from "react-router-dom"

const IndexToolbox = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get("tab") || "PriceCalculator"
  const [active, setActive] = useState(activeTab)

  const toggle = (tab) => {
    setActive(tab)
    setSearchParams((params) => {
      params.set("tab", tab)
      return params
    })
  }

  return (
    <Card>
      <Nav tabs>
        <NavItem>
          <NavLink active={active === "PriceCalculator"} onClick={() => toggle("PriceCalculator")}>
            Price Calculator
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink active={active === "IpWarmup"} onClick={() => toggle("IpWarmup")}>
            IP Warmup
          </NavLink>
        </NavItem>
        {/* 12.03.24 - Robin asked to hide the menu from sellers and leave the module accessible via URL */}
        {/* <NavItem>
          <NavLink
            active={active === "PriceConverter"}
            onClick={() => toggle("PriceConverter")}
          >
            Price Converter
          </NavLink>
        </NavItem> */}
      </Nav>

      <TabContent activeTab={active} style={{ padding: "2rem" }}>
        <TabPane tabId="PriceCalculator">
          <PriceCalculatorForm />
        </TabPane>
        <TabPane tabId="IpWarmup">
          <IpWarmupForm />
        </TabPane>
        <TabPane tabId="PriceConverter">
          <PriceConverterForm />
        </TabPane>
      </TabContent>
    </Card>
  )
}

export default IndexToolbox
